import { render } from "./Kardex.vue?vue&type=template&id=243487cb"
import script from "./Kardex.vue?vue&type=script&lang=js"
export * from "./Kardex.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__